import Skeleton from '@/common/components/Skeleton'
import { formatCurrency } from '@/common/utils/formatters'
import { BillingSupplyAuthorizationEstimate } from '@/features/billingBills/types/billingSupplyAuthorizationEstimate.type'

interface SupplyAuthorizationTotalsProps {
  totals?: BillingSupplyAuthorizationEstimate['totals']
}

export const SupplyAuthorizationTotals = ({ totals }: SupplyAuthorizationTotalsProps) => {
  return (
    <div className="grid grid-cols-3 gap-2">
      <div className="flex flex-col justify-center h-20 gap-2 bg-white-100 rounded-lg p-4 shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]">
        <p className="text-[10px] text-white-800">Valor consumido</p>

        <p className="text-yellow-400">{formatCurrency(Number(totals?.consumed_total))}</p>
      </div>

      <div className="flex flex-col justify-center h-20 gap-2 bg-white-100 rounded-lg p-4 shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]">
        <p className="text-[10px] text-white-800">Total em reais aprovado</p>

        <p className="text-valid">{formatCurrency(Number(totals?.total_of_approved_supplies))}</p>
      </div>

      <div className="flex flex-col justify-center h-20 gap-2 bg-white-100 rounded-lg p-4 shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]">
        <p className="text-[10px] text-white-800">Total em reais pendente</p>

        <p className="text-danger-soft">
          {formatCurrency(Number(totals?.consumed_total) - Number(totals?.total_of_supplies))}
        </p>
      </div>
    </div>
  )
}

export const SupplyAuthorizationTotalsSkeleton = () => {
  return (
    <div className="grid grid-cols-3 gap-2">
      <Skeleton className="h-20 rounded-lg p-4 shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]" />

      <Skeleton className="h-20 rounded-lg p-4 shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]" />

      <Skeleton className="h-20 rounded-lg p-4 shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]" />
    </div>
  )
}
